import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/plantao`

    return {
        datatable(queryParms) {

            return repository.get(`${baseUrl}/datatable?${urlUtil.serialize(queryParms)}`)
        },
        index(queryParms = {}) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list() {

            return repository.get(`${baseUrl}/list`)
        },
        create() {

            return repository.get(`${baseUrl}/create`)
        },
        show(id) {

            return repository.get(`${baseUrl}/${id}`)
        },
        edit(id) {

            return repository.get(`${baseUrl}/${id}/edit`)
        },
        store(params) {

            return repository.post(`${baseUrl}`, params)
        },
        patch(id, params) {

            return repository.patch(`${baseUrl}/${id}`, params)
        },
        updateAllStatus(params) {

            return repository.patch(`${baseUrl}/status`, params)
        },
        destroy(id) {

            return repository.delete(`${baseUrl}/${id}`)
        },
        destroyAll(params) {

            return repository.patch(`${baseUrl}/delete`, params)
        },
    }
}